import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { cn } from '../lib/utils';
import { phases, systemIncludes, tools } from '../data/system';
export function SystemBlueprint() {
  return <section aria-label="Los 6 volúmenes del sistema" className="bg-navy text-white" data-id="element-244" data-mp="29sbrptbvo7vl">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:py-24" style={{
      paddingTop: "20px",
      paddingBottom: "28px"
    }} data-id="element-245" data-mp="24ts13fmca7ww">
        <div className="mx-auto max-w-3xl text-center" data-id="element-246" data-mp="1zxa26wdox3sh">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-aqua" data-id="element-247" data-mp="1vtlt299eu054">
            Sistema Triatlón Completo™ · El sistema integral de preparación para triatlón
          </p>
          <h2 className="mt-4 font-display text-4xl font-extrabold uppercase leading-[0.95] sm:text-6xl" data-id="element-248" data-mp="1lw7dscz83hee">
            Un sistema para organizar el recorrido desde los fundamentos hasta la competición.
          </h2>
          <p className="mt-5 text-lg font-semibold text-white/70" data-id="element-249" data-mp="3g9gog83i98y8">Los 6 volúmenes de Sistema Triatlón Completo™</p>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-250" data-mp="yvsbmvqdi5sz">
          {phases.map((p, idx) => {
          const Icon = p.icon;
          return <motion.article key={p.n} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.3,
            delay: idx % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex h-full flex-col rounded-2xl border border-white/10 bg-obsidian/60 p-6" data-id="element-251" data-mp="12vu9etszmf2z" data-mpi={idx}>
                <div className="flex items-center justify-between" data-id="element-252" data-mp="17xjhc0kwycmu">
                  <span className="font-display text-5xl font-extrabold leading-none text-electric" data-id="element-253" data-mp="17v5ozzhmbeiz">{p.n}</span>
                  <span className="rounded-md border border-aqua/25 bg-aqua/10 px-2 py-1 text-[11px] font-semibold uppercase tracking-wider text-aqua" data-id="element-254" data-mp="1cu09r6z5bd5q">
                    {p.tag}
                  </span>
                </div>
                <div className="mt-4 flex gap-1" aria-hidden="true" data-id="element-255" data-mp="2f95x5zztgcjc">
                  {phases.map((_, k) => <span key={k} className={cn('h-1 flex-1 rounded-full', k < idx ? 'bg-perf' : k === idx ? 'bg-electric' : 'bg-white/10')} data-id="element-256" data-mp="2a9t42xicq98b" data-mpi={k} />)}
                </div>
                <h3 className="mt-5 font-display text-2xl font-extrabold uppercase leading-tight" data-id="element-257" data-mp="25cjftl6p83m2">{p.title}</h3>
                <p className="mt-2 font-semibold leading-snug text-white" data-id="element-258" data-mp="21b7jyxx8em5f">{p.lead}</p>
                <p className="mt-2 text-sm leading-relaxed text-white/65" data-id="element-259" data-mp="1wbuzgjtu1r60">{p.desc}</p>
                <p className="mt-auto flex items-center gap-2 pt-5 text-xs font-semibold uppercase tracking-wider text-white/45" data-id="element-260" data-mp="1rhqsi0kkhj4x">
                  <Icon className="h-4 w-4 text-aqua" aria-hidden="true" data-id="element-261" data-mp="1hkvvxn7utsta" />
                  Volumen {p.n} de 06
                </p>
              </motion.article>;
        })}
        </div>

        <div className="mt-14" data-id="element-262" data-mp="1dld92lwh37nt">
          <p className="text-center font-display text-2xl font-extrabold uppercase sm:text-3xl" data-id="element-263" data-mp="18kfqw9bgqdmb">
            Además, 4 herramientas complementarias
          </p>
          <p className="mt-2 text-center text-sm text-white/60" data-id="element-264" data-mp="3k9nem6dk8dfz">
            Todo organizado en un sistema que conecta entrenamiento, preparación, nutrición y seguimiento.
          </p>
          <ol className="mt-8 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-265" data-mp="3t8r17kbxraz8">
            {tools.map(({
            verb,
            name,
            icon: Icon
          }) => <li key={verb} className="flex flex-col gap-3 bg-navy p-5" data-id="element-266" data-mp="31f8daa3s08oz">
                <Icon className="h-5 w-5 text-electric" aria-hidden="true" data-id="element-267" data-mp="35j6h2y41q7od" />
                <p className="font-display text-2xl font-extrabold uppercase leading-none" data-id="element-268" data-mp="3agonagqoi8so">{verb}</p>
                <p className="text-sm leading-snug text-white/60" data-id="element-269" data-mp="3f9hr92ebpd3p">{name}</p>
              </li>)}
          </ol>
        </div>

        <div className="mt-14 rounded-2xl border border-white/10 bg-obsidian/50 p-6 sm:p-8" data-id="element-270" data-mp="2hssispuvbclc">
          <p className="font-display text-2xl font-extrabold uppercase" data-id="element-271" data-mp="2mqkn6jcp8r6f">Cada parte del sistema aborda aspectos como</p>
          <ul className="mt-6 grid gap-x-6 gap-y-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-272" data-mp="t7c008grmtm5">
            {systemIncludes.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] text-white/80" data-id="element-273" data-mp="o8ilccpqswke">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-perf" strokeWidth={3} aria-hidden="true" data-id="element-274" data-mp="123kynkwx5o78" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}